exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".addEditMenuItemDialog {\n  max-width: 400px !important; }\n  .addEditMenuItemDialog .list-item {\n    margin-top: 15px; }\n  .addEditMenuItemDialog .select-type {\n    margin-bottom: 10px; }\n\n.label-select-type {\n  color: #777777 !important; }\n\n.select-menu-type-root {\n  min-width: 100px; }\n  .select-menu-type-root::after {\n    border-bottom: 2px solid #777777 !important; }\n\n.date-picker {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  margin-top: 15px; }\n  .date-picker span {\n    font-size: .8rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/menu/AddEditItem/AddEditItem.scss
// module id = 1628
// module chunks = 0